const { createSelector } = require('reselect')

const selectGroupList = state => state.groupDomain.groupList

const getGroupList = () => createSelector(
  [selectGroupList],
  cse => cse.data,
)

const getGroupListError = () => createSelector(
  [selectGroupList],
  cse => cse.error,
)

const getGroupListLoading = () => createSelector(
  [selectGroupList],
  cse => cse.loading,
)

const selectGroup = state => state.groupDomain.group

const getGroup = () => createSelector(
  [selectGroup],
  cse => cse.data,
)

const getGroupError = () => createSelector(
  [selectGroup],
  cse => cse.error,
)

const getGroupLoading = () => createSelector(
  [selectGroup],
  cse => cse.loading,
)

const selectCreate = state => state.groupDomain.create

const getCreateGroup = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateGroupError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateGroupLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.groupDomain.update

const getUpdateGroup = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateGroupError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateGroupLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)

const selectDelete = state => state.groupDomain.delete

const getDeleteGroupRes = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteGroupError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteGroupLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

module.exports = {
  getGroupList,
  getGroupListLoading,
  getGroupListError,
  getGroup,
  getGroupLoading,
  getGroupError,
  getCreateGroup,
  getCreateGroupLoading,
  getCreateGroupError,
  getUpdateGroup,
  getUpdateGroupLoading,
  getUpdateGroupError,
  getDeleteGroupRes,
  getDeleteGroupError,
  getDeleteGroupLoading,
}
